export default "__VITE_ASSET__pLg66JQd__"